const React = require("react");
const ArtistDashboardContext = require("./context");

module.exports = (Component) => (props) => (
  <ArtistDashboardContext.Consumer>
    {(contextProps) => <Component {...{ ...props, context: contextProps }} />}
  </ArtistDashboardContext.Consumer>
);
